import React, { useEffect, useState } from 'react';

import useResourceOnboardingSequence from 'app/components/Resources/hooks/useResourceOnboardingSequence';

import ResourceOnboardingSequenceClose from '../ResourceOnboardingSequenceClose';
import ResourceOnboardingSequenceNext from '../ResourceOnboardingSequenceNext';
import {
  ResourceOnboardingSequenceStepCounter,
  ResourceOnboardingSequenceStepInformationContainer,
  ResourceOnboardingSequenceStepTitle,
} from '../styled';
import {
  ResourceOnboardingSequenceCalloutContainer,
  ResourceOnboardingSequenceHeartWrapper,
  ResourceOnboardingSequenceStepTwoWrapper,
} from './styled';

export default function ResourceOnboardingSequenceStepTwo() {
  return (
    <ResourceOnboardingSequenceStepTwoWrapper>
      <ResourceOnboardingSequenceHeartWrapper />
      <ResourceOnboardingSequenceStepTwoCallout />
    </ResourceOnboardingSequenceStepTwoWrapper>
  );
}

function ResourceOnboardingSequenceStepTwoCallout() {
  const { hideLastStep } = useResourceOnboardingSequence();

  return (
    <ResourceOnboardingSequenceCalloutContainer>
      {!hideLastStep ? (
        <ResourceOnboardingSequenceNext style={{ right: '-6px' }} />
      ) : (
        <ResourceOnboardingSequenceClose style={{ right: '-6px' }} />
      )}
      <ResourceOnboardingSequenceStepInformationContainer
        style={{ maxWidth: '187px', position: 'absolute', top: '18px', right: '18px' }}
      >
        <ResourceOnboardingSequenceStepCounter>
          2/{!hideLastStep ? '3' : '2'}
        </ResourceOnboardingSequenceStepCounter>
        <ResourceOnboardingSequenceStepTitle>
          Spread the word by sharing the link around!
        </ResourceOnboardingSequenceStepTitle>
      </ResourceOnboardingSequenceStepInformationContainer>
      <svg
        width="248"
        height="114"
        viewBox="0 0 248 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'relative', zIndex: 2 }}
      >
        <g filter="url(#filter0_bd_41480_1304)">
          <mask
            id="path-1-outside-1_41480_1304"
            maskUnits="userSpaceOnUse"
            x="4.46191"
            y="0.53125"
            width="240"
            height="105"
            fill="black"
          >
            <rect fill="white" x="4.46191" y="0.53125" width="240" height="105" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M38.9995 2.53125C30.163 2.53125 22.9995 9.6947 22.9995 18.5313V42.0186L7.56749 49.7346C6.09339 50.4716 6.09339 52.5752 7.56749 53.3123L22.9995 61.0283V87.5312C22.9995 96.3678 30.163 103.531 38.9995 103.531H226C234.836 103.531 242 96.3678 242 87.5312V18.5312C242 9.69469 234.836 2.53125 226 2.53125H38.9995Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.9995 2.53125C30.163 2.53125 22.9995 9.6947 22.9995 18.5313V42.0186L7.56749 49.7346C6.09339 50.4716 6.09339 52.5752 7.56749 53.3123L22.9995 61.0283V87.5312C22.9995 96.3678 30.163 103.531 38.9995 103.531H226C234.836 103.531 242 96.3678 242 87.5312V18.5312C242 9.69469 234.836 2.53125 226 2.53125H38.9995Z"
            fill="#EB823D"
            fillOpacity="0.3"
            shape-rendering="crispEdges"
          />
          <path
            d="M22.9995 42.0186L23.894 43.8074L24.9995 43.2546V42.0186H22.9995ZM7.56749 53.3123L6.67305 55.1011H6.67306L7.56749 53.3123ZM22.9995 61.0283H24.9995V59.7923L23.894 59.2395L22.9995 61.0283ZM24.9995 18.5313C24.9995 10.7993 31.2676 4.53125 38.9995 4.53125V0.53125C29.0584 0.53125 20.9995 8.59013 20.9995 18.5313H24.9995ZM24.9995 42.0186V18.5313H20.9995V42.0186H24.9995ZM8.46192 51.5234L23.894 43.8074L22.1051 40.2297L6.67306 47.9457L8.46192 51.5234ZM8.46192 51.5234L8.46192 51.5234L6.67306 47.9457C3.72487 49.4198 3.72486 53.627 6.67305 55.1011L8.46192 51.5234ZM23.894 59.2395L8.46191 51.5234L6.67306 55.1011L22.1051 62.8172L23.894 59.2395ZM24.9995 87.5312V61.0283H20.9995V87.5312H24.9995ZM38.9995 101.531C31.2676 101.531 24.9995 95.2632 24.9995 87.5312H20.9995C20.9995 97.4724 29.0584 105.531 38.9995 105.531V101.531ZM226 101.531H38.9995V105.531H226V101.531ZM240 87.5312C240 95.2632 233.732 101.531 226 101.531V105.531C235.941 105.531 244 97.4724 244 87.5312H240ZM240 18.5312V87.5312H244V18.5312H240ZM226 4.53125C233.732 4.53125 240 10.7993 240 18.5312H244C244 8.59012 235.941 0.53125 226 0.53125V4.53125ZM38.9995 4.53125H226V0.53125H38.9995V4.53125Z"
            fill="#FFA366"
            mask="url(#path-1-outside-1_41480_1304)"
          />
        </g>
        <defs>
          <filter
            id="filter0_bd_41480_1304"
            x="-31.5381"
            y="-35.4688"
            width="311.538"
            height="177"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="18" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_41480_1304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              mode="normal"
              in2="effect1_backgroundBlur_41480_1304"
              result="effect2_dropShadow_41480_1304"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_41480_1304"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </ResourceOnboardingSequenceCalloutContainer>
  );
}
